import {
  EXCHANGES_SET_PRIMARY_SHIPPING_ADDRESS,
  EXCHANGES_SET_SELECTED_SHIPPING_ADDRESS_ID
} from 'store/ducks/exchanges/types';

const defaultState = {
  selectedAddressId: null,
  confirmedAddressId: null,
  canCancelAddress: true,
  canChangeAddress: true
};

export default function exchangesReducer(state = defaultState, action = {}) {
  const {
    type,
    selectedAddressId
  } = action;

  switch (type) {

    case EXCHANGES_SET_PRIMARY_SHIPPING_ADDRESS: {
      return { ...state, confirmedAddressId: selectedAddressId };
    }

    case EXCHANGES_SET_SELECTED_SHIPPING_ADDRESS_ID: {
      return { ...state, selectedAddressId };
    }

    default: {
      return state;
    }
  }
}
